import "./ProjectTree.css";

import { useSelector } from "react-redux";

import { getProjectTree } from "slices/project_work";

import ProjectTreeRowWrapper from "./ProjectTreeRowWrapper";

export default function ProjectTree({ callbacks }) {
	const projectTree = useSelector(getProjectTree);
	const treeDom = [];

	for (let row of projectTree) {
		treeDom.push(
			<div key={row.key} className="project-tree-row-wrap">
				<ProjectTreeRowWrapper rowObj={row} callbacks={callbacks} />
			</div>
		);
	}
	return treeDom;
}
